import { StopperNamesConstants } from "../../../Constants/StopperNamesConstants";
import { AABB } from "../../../Utils/AABB";
import { Point } from "../../../Utils/Point";
import { CollisionSubjectModel } from "./CollisionSubjectModel";

export class StopperCollisionModel extends CollisionSubjectModel {
    public name: StopperNamesConstants  = StopperNamesConstants.Bench;

    private _mapSize = {
        [StopperNamesConstants.Bench]: new Point(126, 206),
        [StopperNamesConstants.Bicycle]: new Point(206, 247),
        [StopperNamesConstants.Gidrant]: new Point(243, 150),
        [StopperNamesConstants.Hatch]: new Point(154, 187),
        [StopperNamesConstants.Mail]: new Point(154, 187),
        [StopperNamesConstants.Menu]: new Point(127, 151),
        [StopperNamesConstants.Urn]: new Point(188, 204),
    };


    get aabb() {
        return new AABB(new Point(this.pos.x, this.pos.y - this.height), new Point(this.pos.x + this.width, this.pos.y));
    }

    get width() {
        return this._mapSize[this.name].x;
    }

    get height() {
        return this._mapSize[this.name].y;
    }
}